import { graphql } from "gql";

const USER_ATTRIBUTE_QUERY = graphql(`
  query UserAttribute($id: [ID!]!) {
    userAttributes: userAttribute(id: $id) {
      ...UserAttribute
    }
  }
`);

export default USER_ATTRIBUTE_QUERY;
